import { render } from "./ScreenClock.vue?vue&type=template&id=69d2b622&scoped=true"
import script from "./ScreenClock.vue?vue&type=script&lang=js"
export * from "./ScreenClock.vue?vue&type=script&lang=js"

import "./ScreenClock.vue?vue&type=style&index=0&id=69d2b622&lang=scss&scoped=true"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d2b622"]])

export default __exports__